import { getPublicEnv } from '@tucan/utils'

export const isAudio = (
  file: { type?: string; name: string },
  extraExtensions: string[] = [],
): boolean => {
  const types = [
    ...String(getPublicEnv('SUPPORTED_FILE_TYPES')).toLowerCase().split(','),
    ...extraExtensions.map(ext => ext.toLowerCase()),
  ]

  return types.some(check => {
    if (check.startsWith('.')) {
      return file.name.toLowerCase().endsWith(check)
    }

    return new RegExp(check.replace('*', '.*'), 'i').test(file.type ?? '')
  })
}
